
export enum ImportWriteMode {
	ReadOnly,
	WriteAll,
	// for auditors
	WriteAuditReview,
	// for collaborating physicians
	WriteCollaboratingPhysician,
}
